import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
const HeroSection: React.FC = () => {
  return <section className="bg-gradient-to-b from-blue-50 to-white py-16 md:py-24">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
          Grow Your Business With <span className="text-primary-blue">Referrals</span>
        </h1>
        <p className="text-xl text-gray-800 mb-10 max-w-2xl mx-auto">
          Our referral program makes it easy to reward your customers for spreading the word. Track, manage, and grow your business through word-of-mouth.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link to="/business-signup">
            <Button size="lg" variant="arrow" className="px-8">
              Start Your Free Trial <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
          <Link to="/login">
            <Button size="lg" variant="outline" className="px-8">
              Log In
            </Button>
          </Link>
        </div>
      </div>
    </section>;
};
export default HeroSection;